// extracted by mini-css-extract-plugin
module.exports = {"roster":"roster_roster__UYmHr"};